export const props = Object.freeze({
  /**
   * Name of the translated attribute, as the server knows it (`biography`). Sent with a Clara
   * request.
   * @type {String}
   * @default undefined
   */
  attribute: {
    type: String,
    default: undefined,
  },
  /**
   * Human name of the translated attribute (`Biography`), as the page's translation toolbar lists
   * it.
   * @type {String}
   * @default undefined
   */
  label: {
    type: String,
    default: undefined,
  },
  /**
   * The languages the field can be translated into: `[{ locale, name }]`, as a JSON attribute or an
   * array property. Each `locale` matches the `data-locale` of one slotted field.
   * @type {Array|String}
   * @default []
   */
  languages: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * Locale of the base field (the untranslated value), matching its `data-locale`.
   * @type {String}
   * @default "en"
   */
  defaultLocale: {
    type: String,
    default: "en",
  },
  /**
   * Name of the base field's language, shown in the selector.
   * @type {String}
   * @default undefined
   */
  defaultLanguageName: {
    type: String,
    default: undefined,
  },
  /**
   * Type of the record the field belongs to (`Physician`). Sent with a Clara request.
   * @type {String}
   * @default undefined
   */
  resourceType: {
    type: String,
    default: undefined,
  },
  /**
   * Id of the record the field belongs to. Sent with a Clara request.
   * @type {String|Number}
   * @default undefined
   */
  resourceId: {
    type: [String, Number],
    default: undefined,
  },
  /**
   * Endpoint a Clara request is posted to. Without it the field offers no Clara action.
   * @type {String}
   * @default undefined
   */
  translateUrl: {
    type: String,
    default: undefined,
  },
});
